export enum RegulatoryStatusEnum {
  All = 0,
  Regulatory = 1,
  NonRegulatory = 2,
  NotOnALocation = 3
}

export class MachineDeviceSearchRequest {
  fromDate: Date | string;
  toDate: Date | string;
  costCenterID: number;
  routeIDList: number[];
  majorAccountId: number;
  accountLocationList: number[];
  machineNumber: number;
  deviceNo: string;
  requestStatusCode: string;
  rpcActivation: string;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
}

export class PogDexDiscrepancySearchRequest {
  costCenterID: number;
  routeIDList: number[];
  majorAccountId: number;
  vendorCode: string;
  accountLocationList: number[];
  machineNumber: number;
  deviceStatusCode: string;
  requestStatusCode: string;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
}

export class RpcTrackStatusSearchRequest {
  costCenterID: number;
  majorAccountId: number;
  accountLocationList: number[];
  routeIDList: number[];
  updatedMachineModel: string;
  vendorCode: string;
  upgradeSteps: string;
  upgradeStepsLookupID: number;
  upgradeNotNeededReason: string;
  upgradeNotNeededReasonLookupID: number;
  upgradeNeeded: string[];
  upgradeNeededLookupIDs: number[];
  upgradeComplete: string[];
  upgradeCompleteLookupIDs: number[];
  testingStatus: string[];
  testingStatusLookupIDs: number[];
  testingComplete: string[];
  testingCompleteLookupIDs:number[];
  deviceNo: string;
  machineNumber: number;
  regulatoryStatus: number;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;

  constructor() {
    this.upgradeNeeded = new Array();
    this.upgradeComplete = new Array();
    this.testingStatus = new Array();
    this.testingComplete = new Array();
    this.upgradeNeededLookupIDs = new Array();
    this.upgradeCompleteLookupIDs = new Array();
    this.testingStatusLookupIDs = new Array();
    this.testingCompleteLookupIDs = new Array();
    this.pageSize = 1000; //hardcoded for now;
    this.pageNumber = 1;
    this.sortDirection = 'ASC';
    this.regulatoryStatus = RegulatoryStatusEnum.All;
  }
}

export interface MachineDeviceSearchItem {
  costCenterID: number,
  accountID: number,
  accountName: string,
  locationID: number, 
  locationName:string,
  machineID: number,
  machineNumber:number,
  dispenseMethodID: number,
  dispenseMethodName:string,
  routeID: number,
  routeNumber: number,
  planogramId: number,
  lastpogEffectiveDate: Date,
  viDeviceId: number,
  vendorCode: string,
  deviceNo: string,
  deviceStartDateTime: Date,
  rpcCompatible: boolean,
  rpcEnabled: boolean,
  rpcEnabledDateTime: Date,
  rpcAutoSend: boolean,
  rpcAutoSendModifiedDateTime: Date,
  rpcSendDate: Date,
  rpcStatus: string,
  requestStatusCode: string,
  deviceStatusCode: string,
  errorMessage: string,
  rowIsDirty: boolean
}

export class MachineDeviceExcelExportItem {
  AccountLocation: string;
  Route:number;
  Machine:number;
  MachineType:string;
  POGEffective: string;
  DeviceNo: string;
  RPCCompatible: string;
  RPCEnabled: string;
  RPCEnabledDate: string;
  RPCAutoSend: string;
  RPCAutoSendSetDate: string;
  Status: string;
  RPCSendDate: string;
  ErrorMessage: string;
}


export interface PogDexDiscrepancySearchItem {
  costCenterID: number,
  accountID: number,
  accountName: string,
  locationID: number, 
  locationName:string,
  machineID: number,
  machineNumber:number,
  planOGramID:number,
  viDeviceID: number,
  vendorCode: string,
  deviceNo: string,
  deviceStatusCode: string,
  requestStatusCode: string,
  statusCode: string,
  routeID: number,
  routeNumber: number,
  dexType: string,
  selection: string,
  dexPrice: number,
  currentPogPrice: number,
  productName: string,
  rpcEnabled: boolean,
  rpcEnabledDateTime: Date,
  rpcAutoSendEnabledInd: boolean,
  rpcSend: boolean,
  rpcSendDate: Date,
  details: PogDexDiscrepancySearchDetail[],
  isCollapsed: boolean
}

export interface PogDexDiscrepancySearchDetail {
  machineID: number,
  planOGramSelectionID: number,
  selectionName: string,
  dexName: string,
  productLongName: string,
  pogPrice: number,
  dexPrice: number
}

export class PogDexDiscrepancyDisplayItem {
  accountName: string;
  locationName: string;
  routeNumber: number;
  vendorCode: string;
  deviceNo: string;
  machineId: number;
  machineNumber: number;
  dexType: string;
  selection: string;
  dexPrice: number;
  currentPogPrice: number;
  productLongName: string;
  rpcOn: string;
  rpcAutoSendEnabledInd: boolean;
  rpcSend: boolean;
  rpcSendDate: Date;
  requestStatusCode: string;
  deviceStatusCode: string;
  isHeaderItem: boolean;
  isCollapsed: boolean;
}

export interface RouteLineItem {
  displayName: string;
  routeID: number;
  routeNumber: number;
  selected: boolean;
  preselectAllRoutes: boolean;
}

export class RPCDexPriceDiscrepenciesFilter {
  vendorCode: string;
  machineNumber: number;
}


export interface MachineDeviceSearchMetadata {
  totalItemCount: number;
}

export interface PogDexDiscrepancySearchMetadata {
  totalItemCount: number;
}

export class MachineDeviceSearchResponse {
  items: MachineDeviceSearchItem[];
  metadata: MachineDeviceSearchMetadata;
  routeLineItems: RouteLineItem[];
}

export class PogDexDiscrepancySearchResponse {
  items: PogDexDiscrepancySearchItem[];
  metadata: MachineDeviceSearchMetadata;
}

export class MachineDeviceSelectionPriceStatusUpdateRequest {
  costCenterID: number;
  requestStatusCode: string;
  userID: number;
}

export class MachineDeviceSelectionPriceStatusUpdateItem {
  machineNumber: number;
  deviceNo: string;
  statusCode: string;
  errorMessage: string;
}

export class MachineDeviceSelectionPriceStatusUpdateResponse {
  items: MachineDeviceSelectionPriceStatusUpdateItem[];
}

export class MachineDeviceRpcUpdate {
  viDeviceId: number;
  vendorCode: string;
  rpcEnabled: boolean;
  rpcAutoSend: boolean;
  userId: number;
}

export class MachineDeviceSelectionPriceRequestSelection {
  planOGramSelectionID: number;
  name: string;
  dexName: string;
  price: number;
}

export class MachineDeviceSelectionPriceRequest {

  requestGuid: string;
  operationNo: string;
  lob: string = "V";
  vendorCode: string;
  viDeviceID: number;
  deviceNo: string;
  machineNumber: number;
  machineID: number;
  userID: number;
  planOGramID: number;
  selectionList: Array<MachineDeviceSelectionPriceRequestSelection>;

  constructor() {
    this.selectionList = new Array<MachineDeviceSelectionPriceRequestSelection>();
  }

  private generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }  

  public setFromItem(item: PogDexDiscrepancySearchItem) {
    this.requestGuid = this.generateGUID();
    this.operationNo = `${item.costCenterID}`;
    this.lob = "V";
    this.vendorCode = item.vendorCode.trim();
    this.viDeviceID = item.viDeviceID;
    this.deviceNo   = item.deviceNo;
    this.machineNumber = item.machineNumber;
    this.machineID = item.machineID;
    this.planOGramID = item.planOGramID;

    item.details.forEach(detail=>{
      let selectionItem = new MachineDeviceSelectionPriceRequestSelection();
      selectionItem.planOGramSelectionID = detail.planOGramSelectionID;
      selectionItem.name = detail.selectionName;
      selectionItem.dexName = detail.selectionName;
      selectionItem.price = detail.pogPrice;
      this.selectionList.push(selectionItem);
    });
  }


}

export class RpcStatusFilterRequest {
  column: string;
  filter: string;
}

export class iVendLookup {
  iVendLookupID: number;
  typeName: string;
  enumerationValue: string;
  description: string;
}

export interface RPCTrackStatusMetadata {
  totalItemCount: number;
}

export class RPCTrackStatusItemException {
  message: string;
}

export class RPCTrackStatusItem {
  rpcTrackStatusID: number;
  customer: string;
  accountID: number;
  locationID: number;
  accountName: string;
  locationName: string;
  accountLocation: string;
  machineID: number;
  machineNumber: number;
  routeID: number;
  routeNumber: number;
  machineSerialNumber: string;
  dexSerialNumber: string;
  updatedMachineModel: string;
  capitalAssetNumber: string;
  vendorCode: string;
  deviceNo: string;
  partNumber: string;
  isValidMachineDeviceCombination: boolean;
  upgradeStepsLookupID: number;
  upgradeSteps: string;
  upgradeNeeded: number;
  upgradeNeededDisplay: string;
  upgradeComplete: number;
  upgradeCompleteDisplay: string;
  upgradeTechnicianName: string;
  upgradeNotNeededReason: string;
  upgradeNotNeededReasonLookupID: number;
  upgradeCompletedDateTime: Date;
  testingStatus: number;
  testingStatusDisplay: string;
  testingComplete: number;
  testingCompleteDisplay: string;
  isRegulatory: boolean;
  dirty: boolean;
  invalidUpdate: boolean;
  exceptions: RPCTrackStatusItemException[];
}

export interface RPCTrackStatusResponse {
  metadata: RPCTrackStatusMetadata;
  iVendLookups: iVendLookup[];
  items: RPCTrackStatusItem[];
}

export interface RpcTrackStatusSummary {
  noUpgradeNeeded: { reg: number; nonReg: number; notOnLocation: number };
  upgradeCompleted: { reg: number; nonReg: number; notOnLocation: number };
  remainingUpgrade: { reg: number; nonReg: number; notOnLocation: number };
}

export interface RPCTrackStatusSummaryResponse {
  summary: RpcTrackStatusSummary;
}

export class RPCTrackStatusSaveRequest {
  items: RPCTrackStatusItem[];
  userId: number;
}

export class RPCTrackStatusItemsSaveResponseException {
  message: string;
}

export class RPCTrackStatusSaveResponse {
  items: RPCTrackStatusItem[];
  exceptions: RPCTrackStatusItemsSaveResponseException[];
}

export class RPCTrackStatusExcelItem {
  Customer: string;
  RouteNumber: number;
  AccountLocation: string;
  MachineNumber: number;
  MachineSerialNumber: string;
  DEXSerialNumber: string;
  UpdatedMachineModel: string;
  CapitalAssetNumber: string;
  VendorCode: string;
  DeviceNo: string;
  UpgradeSteps: string;
  PartNumber: string;
  UpgradeNeeded: string;
  Reason: string;
  UpgradeComplete: string;
  TechnicianName: string;
  CompletedDate: string;
  TestingStatus: string;
  TestingComplete: string;
}

// ------------------------------------------------------------------------------

export class RPCMachineDeviceCompatibilityFilter {
  vendorCodes: string;
  machineModels: string;
  deviceNo: string;
  rpcCompatibleInd: boolean;
  dexSinceDateTime: Date;
  machineActions: string;
  messages: Message[];
}

export class RPCMachineDeviceCompatibilityItemsRequest {
  constructor() {
    this.majorAccountId=null;
    this.sortColumn='accountlocation';
    this.sortDirection='ASC';
  }
  costCenterID: number;
  majorAccountId: number;
  accountLocationList: number[];
  routeIDList: number[];

  rpcCompatibleInd: boolean;
  vendorCodes: string;
  machineModels: string;
  deviceNo: string;
  dexSinceDateTime: Date;
  machineActions: string;

  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
}

export interface RPCMachineDeviceConfigurationResponseMetadata {
  totalItemCount: number;
}

export class RPCMachineDeviceCompatibilityItem {
  rpcMachineDeviceID: number;
  costCenterID: number;
  accountLocation: string;
  locationStreetAddress:string;
  locationCity:string;
  locationState:string;
  locationPostalCode:string;
  latestVIDexDateTime:Date;
  machineID: number;
  machineNumber: number;
  routeNumber: number;
  vendorCode: string;
  deviceNo: string;
  machineSerialNumber: string;
  machineModelNumber: string;
  machineBuildStandard: string;
  userDefinedField: string;
  controlBoardModelNumber: string;
  controlBoardSoftwareRevision: string;
  cashless1ModelNumber: string;
  cashless1SoftwareRevision: string;
  cashless2ModelNumber: string;
  cashless2SoftwareRevision: string;
  rpcCompatibleInd: boolean;
  firmwareActions: string;
  passcodeActions: string;
  dexMissing: string;
  dexDataMissing: string;
  multipleDevices: string;
  missingPOGSelectionOnDex: string;

}

export class RPCMachineDeviceCompatibilityItemsResponse {
  metadata: RPCMachineDeviceConfigurationResponseMetadata;
  items: RPCMachineDeviceCompatibilityItem[];
  iVendLookups: iVendLookup[];
}

export class RPCMachineDeviceCompatibilityExcelItem {
  CostCenterID: number;
  AccountLocation: string;
  LocationStreetAddress: string;
  LocationCity: string;
  LocationState: string;
  LocationPostalCode: string;
  MachineNumber: number;
  RouteNumber: number;
  VendorCode: string;
  DeviceNo: string;
  MachineSerialNumber: string;
  MachineModelNumber: string;
  MachineBuildStandard: string;
  UserDefinedField: string;
  ControlBoardModelNumber: string;
  ControlBoardSoftwareRevision: string;
  CashlessSoftwareRevision: string;
  CashlessModelNumber: string;
  MachineActions: string;
  LatestDEX: Date;
  Status: string;
}

export class UpdatedMachineModel {
  name: string;
}

export class Message {
  costCenterID : number;
  messageText: string;
}

export class Vendor {
  vendorCode: string;
}

export class MachineModel {
  machineModelNumber: string;
}

export class MachineAction {
  machineActionName: string;
}

export class UpgradeStep {
  iVendLookupID: number;
  description: string;
}

export class UpgradeNotNeededReason {
  iVendLookupID: number;
  description: string;
}

export class RPCTrackStatusFilterItemsResponse {
  updatedMachineModels: UpdatedMachineModel[];
  vendors: Vendor[];
  upgradeSteps: UpgradeStep[];
  upgradeNotNeededReasons: UpgradeNotNeededReason[];
}

export class RPCDexPriceDiscrepenciesFilterItemsResponse {
  vendors: Vendor[];
  messages: Message[]
}

export class RPCMachineDeviceCompatibilityFilterItemsResponse {
  vendors: Vendor[];
  machineModels: MachineModel[];
  machineActions: MachineAction[];
  messages: Message[];
}